import React from 'react';
import { ThemeProvider } from '../../hooks/ThemeContext';
import ThemeCustomizer from './ThemeCustomizer';

const ThemeCustomizerPage: React.FC = () => {
    return (
        <ThemeProvider>
            <ThemeCustomizer />
        </ThemeProvider>
    );
};

export default ThemeCustomizerPage;
